export default __webpack_public_path__ + "static/media/MAYSTRODONS.35942dec.svg";